import uppyLocaleEs from '@uppy/locales/lib/es_ES.js'

export default {
    Language: 'Idioma',
    Create: 'Crear',
    Close: 'Cerrar',
    Cancel: 'Cancelar',
    Save: 'Guardar',
    Edit: 'Editar',
    Crop: 'Recortar',
    'New Folder': 'Nueva Carpeta',
    'New File': 'Nuevo Archivo',
    Rename: 'Renombrar',
    Delete: 'Eliminar',
    Upload: 'Subir',
    Download: 'Descargar',
    Archive: 'Archivar',
    Unarchive: 'Desarchivar',
    Open: 'Abrir',
    'Open containing folder': 'Abrir carpeta contenedora',
    Refresh: 'Actualizar',
    Preview: 'Vista previa',
    'Toggle Full Screen': 'Alternar Pantalla Completa',
    'Change View': 'Cambiar Vista',
    Storage: 'Almacenamiento',
    'Go up a directory': 'Subir un directorio',
    'Search anything..': 'Buscar cualquier cosa...',
    Name: 'Nombre',
    Size: 'Tamaño',
    Date: 'Fecha',
    Filepath: 'Ruta del archivo',
    'Folder Name': 'Nombre de la Carpeta',
    'File Name': 'Nombre del Archivo',
    'Move files': 'Mover archivos',
    'Yes, Move!': '¡Sí, mover!',
    'Delete files': 'Eliminar archivos',
    'Yes, Delete!': '¡Sí, eliminar!',
    'Upload Files': 'Subir Archivos',
    'No files selected!': '¡Ningún archivo seleccionado!',
    'Select Files': 'Seleccionar Archivos',
    'Archive the files': 'Archivar los archivos',
    'Unarchive the files': 'Desarchivar los archivos',
    'The archive will be unarchived at': 'El archivo se desarchivará en',
    'Archive name. (.zip file will be created)':
        'Nombre del archivo (.zip será creado)',
    'Vuefinder is a file manager component for vue 3.':
        'Vuefinder es un gestor de archivos para Vue 3.',
    'Create a new folder': 'Crear una nueva carpeta',
    'Create a new file': 'Crear un nuevo archivo',
    'Are you sure you want to delete these files?':
        '¿Estás seguro de que deseas eliminar estos archivos?',
    'This action cannot be undone.': 'Esta acción no se puede deshacer.',
    'Search results for': 'Resultados de búsqueda para',
    '%s item(s) selected.': '%s elemento(s) seleccionado(s).',
    '%s is renamed.': '%s ha sido renombrado.',
    'This is a readonly storage.': 'Este es un almacenamiento de solo lectura.',
    '%s is created.': '%s ha sido creado.',
    'Files moved.': 'Archivos movidos.',
    'Files deleted.': 'Archivos eliminados.',
    'The file unarchived.': 'El archivo ha sido desarchivado.',
    'The file(s) archived.': 'El/los archivo(s) han sido archivados.',
    'Updated.': 'Actualizado.',
    'No search result found.': 'No se encontraron resultados.',
    'Are you sure you want to move these files?':
        '¿Estás seguro de que deseas mover estos archivos?',
    'File Size': 'Tamaño del Archivo',
    'Last Modified': 'Última Modificación',
    'Select Folders': 'Seleccionar Carpetas',
    'Clear all': 'Limpiar todo',
    'Clear only successful': 'Limpiar solo los exitosos',
    'Drag and drop the files/folders to here or click here.':
        'Arrastra y suelta los archivos/carpetas aquí o haz clic aquí.',
    'Release to drop these files.': 'Suelta para subir los archivos.',
    Canceled: 'Cancelado',
    Done: 'Hecho',
    'Network Error, Unable establish connection to the server or interrupted.':
        'Error de red, no se pudo establecer la conexión al servidor o fue interrumpida.',
    'Pending upload': 'Subida pendiente',
    'Please select file to upload first.':
        'Por favor selecciona un archivo para subir primero.',
    About: 'Acerca de',
    Settings: 'Configuraciones',
    Shortcuts: 'Atajos',
    Reset: 'Restablecer',
    Escape: 'Escape',
    Search: 'Buscar',
    'Toggle Sidebar': 'Alternar Barra Lateral',
    'Open Settings': 'Abrir Configuraciones',
    'Reset all settings to default':
        'Restablecer todas las configuraciones por defecto',
    'Use Metric Units': 'Usar Unidades Métricas',
    'Saved.': 'Guardado.',
    'Reset Settings': 'Restablecer Configuraciones',
    'Download doesn\'t work? You can try right-click "Download" button, select "Save link as...".':
        '¿La descarga no funciona? Intenta hacer clic derecho en el botón "Descargar" y seleccionar "Guardar enlace como...".',
    Theme: 'Tema',
    Dark: 'Oscuro',
    Light: 'Claro',
    System: 'Sistema',
    'Target Directory': 'Directorio de Destino',
    Select: 'Seleccionar',
    'Compact list view': 'Vista de lista compacta',
    'Show thumbnails': 'Mostrar miniaturas',
    'Persist path on reload': 'Mantener ruta al recargar',
    'Select All': 'Seleccionar Todo',
    'Pinned Folders': 'Carpetas Fijadas',
    'No folders pinned': 'No hay carpetas fijadas',
    'Pin Folder': 'Fijar Carpeta',
    'Unpin Folder': 'Desfijar Carpeta',
    'Project home': 'Inicio del Proyecto',
    'Follow on GitHub': 'Síguenos en GitHub',
    'Customize your experience with the following settings':
        'Personaliza tu experiencia con las siguientes configuraciones',
    uppy: uppyLocaleEs,
}
